import Content from './Content'
import Footer from './Footer'
import Header from './Header'
import messageResource from "../../../messageResource"
import makeRpcCall from "../../../util/jquery_rpc"
import {setFocusIntoFieldWithPlaceholder} from "../../../atBrowserUtils"
import LightBox from '../../../components/LightBox'
import {Exceptions as CommonExceptions} from '../../../common/constants'
import {NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION} from '../../common/ExceptionsTypes'
import {separateProjectCopySettings} from '../../../panels/project/actions'

const WARNING_ERROR_DURING_IMPORT = 300;
const RESULT_SUCCESSFULL = 200;
const ERROR_NAME_DUPLICATE = 400;

const NAME_EMPTY = "nameEmptyError";
const NAME_DUPLICATE = "nameDuplicateError";
const TAB_SWITCHING_ON_ERROR = 'details';

export default class CreateCustomerLightbox extends LightBox {
    constructor(data,
                {
                    createCustomerStartCb,
                    createCustomerFailureCb,
                    successHandler,
                    copyTasksCb,
                }) {
        super();
        this.exist_invalid_fields_message_key = "customer.edit.correct_errors";
        this.close_tab_confirmation_message_key = "customer.create.close_tab.confirmation";
        this.cancel_confirmation_message_key = "customer.create.exit_confirmation";

        this.params = {
            data,
            createCustomerStartCb,
            createCustomerFailureCb,
            successHandler,
            copyTasksCb,
        }

        this.dataChanged = false;
        this.cancelCallback = this.hide;
        this.errors = {};
        this.warningMessages = {};
        this.warningMessages[WARNING_ERROR_DURING_IMPORT] = messageResource.getMessage('customer.create.error.copied_customer_deleted');
    }

    init() {
        const header = new Header()
        const footer = new Footer()
        const content = new Content(
            this.params.data,
            {
                onChangeNameCb: this._handleChangeNameCb,
                onBlurNameCb: this._handleBlurNameCb,
                onNameKeyUpCb: this._handleNameKeyUpCb,
                onNameKeyPressCb: this._handleNameKeyPressCb,
                onChangeCustomerSelectorCb: () => this.changesCallback(),
                onChangeDescriptionCb: () => this.changesCallback(),
                onChangeCb: () => this.changesCallback(),
                refreshScrollCb: () => this.refreshScroll(),
                scrollToSelectorCb: () => this.scrollToCustomerSelector(),
            }
        )

        super.init(
            {
                id: 'customerLightBox', // do not delete
                header,
                content,
                footer,
                classNames: 'createCustomerLightbox taskProjectOrCustomerLightbox lightboxWithWhiteContent withTabs',
                correctionOffset: -60 /* offset of the innerContent in the popup content used when scrolling to section with error*/
            })

        this.setSuccessCallback(this._successCallback);

        this.setFailureValidateCallback(() =>  this.components.content.openTabByKey(TAB_SWITCHING_ON_ERROR))

        return this
    }

    _successCallback(customerName,
                     customerDescription,
                     customerIdToImportDataFrom,
                     copySettings,
                     assignedUserIds,
                     managerIds) {

        this.disableUserInputWhileSaving();
        this.params.createCustomerStartCb()
        makeRpcCall("CustomerInfoService.createCustomer", [
                customerName,
                customerDescription,
                customerIdToImportDataFrom,
                separateProjectCopySettings(copySettings),
                assignedUserIds,
                managerIds
            ],
            (result) => {
                if (result.resultCode === RESULT_SUCCESSFULL) {
                    if (result.taskIds && result.taskIds.length > 0) {
                        this.params.copyTasksCb(
                            result.taskIds,
                            result.projectsOldIdsToNewIds.map,
                            copySettings,
                            result.operationId,
                        )
                    }

                    if (result.warning) {
                        if (this.warningMessages[result.warning])
                            alert(this.warningMessages[result.warning])
                    } else {
                        if (this.params.successHandler)
                            this.params.successHandler(result)
                    }
                    this.hide();
                }
                else if (result.resultCode === ERROR_NAME_DUPLICATE) {
                    this.displayNameDuplicateError();
                    this.enableUserInputWhileSaving();
                    this.params.createCustomerFailureCb()
                }
            },
            (jqXHR, textStatus, errorThrown) => {
                this.enableUserInputWhileSaving()
                this.params.createCustomerFailureCb()

                switch (errorThrown.exception) {
                    case NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION:
                        alert(messageResource.getMessage("task.create.error.no_manage_scope_right"))
                        window.location.reload()
                        return true
                    case CommonExceptions.USER_IS_NOT_ASSIGNED_TO_MANAGER_EXCEPTION:
                        alert(messageResource.getMessage("task.create.error.user_is_not_assigned_to_manager"))
                        window.location.reload()
                        return true
                    case CommonExceptions.USER_IS_DISABLED_EXCEPTION:
                        alert(messageResource.getMessage("task.create.error.assigned_user_disabled"))
                        window.location.reload()
                        return true
                    case CommonExceptions.NO_SUCH_USER_EXCEPTION:
                        alert(messageResource.getMessage("task.create.error.no_such_user"))
                        window.location.reload()
                        return true
                    case CommonExceptions.USER_HAS_NO_ACCESS_TO_SCOPE_EXCEPTION:
                        alert(messageResource.getMessage("task.create.error.user_does_not_have_any_scope_rights"))
                        window.location.reload()
                        return true
                }
                return false
            }
        );
    };

    _handleChangeNameCb = () => {
        this.changesCallback()
        this.hideNameDuplicateError()
    }

    _handleBlurNameCb = (field) => {
        const handler = this.basicOnBlurFieldHandler(() => { this.checkNameOnChange(); }).bind(field[0])
        handler()
    }

    _handleNameKeyUpCb = () => {
        this.basicKeyUpChangesHandler()
    }

    _handleNameKeyPressCb = () => {
        this.basicOnKeyPressedHandler()
    }

    changesDetected() {
        if (!this.dataChanged)
            this.dataChanged = true;
    }

    validate() {
        return this.isNameValid(false);
    }

    updateUI() {
        this.updateErrors(true);
    }

    getErrorsMap() {
        return this.errors;
    }

    setErrorClasses(classes) {
        this.getContent().setErrorClasses(classes)
    }

    displayErrorInFooter() {
        this._errorMessageBox.removeClass("disabled");
    }

    checkNameOnChange() {
        this.checkEmpty(this.getContent().getNameField(), NAME_EMPTY, true, true);
        this.updateErrors(false);
    }

    isNameValid(onlyRemoveEmptyError) {
        return !this.checkEmpty(this.getContent().getNameField(), NAME_EMPTY, onlyRemoveEmptyError, true);
    }

    displayNameDuplicateError() {
        this.errors[NAME_DUPLICATE] = true;
        this.updateErrors(true);
    }

    hideNameDuplicateError() {
        this.errors[NAME_DUPLICATE] = false;
        this.updateErrors();
    }

    show() {
        super.show();
        setFocusIntoFieldWithPlaceholder(this.getContent().getNameField());
    }

    getDataToCommit() {
        return this.getContent().getData()
    }

    scrollToCustomerSelector() {
        this.getWrapper().scrollToSectionIfNeeded(this.getContent().getCustomerSelectorList())
    }


}


// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/customer/CreateCustomerLightbox.js